export const upcomingEventsPath = '/events/upcoming';
export const pastEventsPath = '/events/past';
export const directoryFirmsPath = '/directory/firms';
export const directoryMembersPath = '/directory/members';
export const directoryDesksPath = '/directory/desks';
export const socialsPath = '/social/articles/.2B3X41MPDekScBAWyLGCkw'